import type { RouteObject } from 'react-router-dom';

let routes: RouteObject[] = [];

export const registerRoutes = (nextRoutes: RouteObject[]) => {
  routes = nextRoutes;
};

export const getRegisteredRoutes = (): RouteObject[] => routes;
